export enum Currency {
  ARS = "ARS",
  USD = "USD",
}
